import React, { useState, useEffect } from "react";
// form
import { useFormik, FormikProvider } from "formik";
import { generateRandomUUID } from "../../../utils/helpers";
import { validationSchemaAdmin } from "./validationSchema";
import ChannelSend from "../multichannel/ChannelSend";
import MessageText from "../multichannel/MessageText";
import { WhatsappForm } from "../multichannel/wa";
import Scheduler from "../Scheduler";
import MessageSimpleRcs from "../multichannel/MessageSimpleRcs";
import _ModalConfirmMulti from "../../modal/_ModalConfirmMulti";
import GeneralData from "./GeneralData";
import { ApiEndpoint } from "../../../utils/ApiEndpoint";
import { httpClient } from "../../../utils/HttpClient";
import { useAuth } from "../../../Context/AuthContext";
import { ErrorMessage, SuccessMessage } from "../../../utils/toastify";
import { useNavigate } from "react-router-dom";
import CreateMessageRcs from "../../../utils/classes/create-message-rcs";
import { EmailForm } from "../multichannel/email";

const NewCampaignAdminForm = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  let { token, uid_user } = auth.getSessionData();
  const [visible, setVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const initialValues = {
    partner: "",
    uidUser: uid_user,
    uuid_campaign: generateRandomUUID(),
    campaignName: "",
    uiddatabase: "",
    id_customer: "",
    mask: "",
    dateSend: "",
    proghour: "",
    hour: 0,
    minute: 0,
    idshortcode: "0",
    listDatabases: [],
    listMask: [],
    listShortLinks: [],
    partnerList: [],
    customersList: [],
    message: "",
    template: "",
    rcsmessage: "",
    isScheduled: false,
    isSms: false,
    isRcs: false,
    isEmail: false,
    isWhatsapp: false,
    whmessage: "",
    whtemplate: "",
    selectedTemplate: "",
    whparameters: "",
    email_message: "",
    email_subject: "",
    email_template: "",
    imageUrl: "",
    height: "",
    carrousel: [],
    title_rcs_message: "",
    step: 1,
    buttonActions: [],
    buttonQuickReplies: [],
    parameters: "",
    fallback: "",
    template_fallback: "",
    thumbnail_url: "",
    cardOrientation: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchemaAdmin,
    validateOnChange: true,
    onSubmit: async (values) => {
      setIsLoading(true);

      try {
        await _action(values);
        SuccessMessage("Campaña enviada con éxito");
        navigate("/Administration/Campaigns");
        formik.resetForm();
      } catch (error) {
        console.log(error);
        ErrorMessage("Error al enviar la campaña");
      } finally {
        setIsLoading(false);
      }
    },
  });

  const _action = async (values) => {
    /*eslint-disable no-unused-vars */


    let uri = "campaigns/createCampaign";

    if (values.isScheduled) {
      uri = "campaigns/programCampaign";
    }

   
    const Resolver = new CreateMessageRcs(values);

    const data = await Resolver.multichannel();
    const res = await httpClient("POST", `${ApiEndpoint}${uri}`, data, token);
    if (res?.data?.error) {
      throw new Error("Error al enviar la campaña");
    }

    return res;
  };

  const getListDatabase = () => {
    httpClient(
      "GET",
      `${ApiEndpoint}configuration/getAdminDatabases`,
      {},
      token,
    ).then((response) => {
      formik.setFieldValue("listDatabases", response?.data, false);
    });
  };

  const getPartnersList = (idCustomer) => {
    httpClient("GET", `${ApiEndpoint}partners/${idCustomer}`, {}, token).then(
      (response) => {
        formik.setFieldValue("partnerList", response.data, false);
      },
    );
  };

  const getCustomersList = () => {
    httpClient("GET", `${ApiEndpoint}customers`, {}, token).then((response) => {
      formik.setFieldValue("customersList", response.data, false);
    });
  };

  const getShortLinks = (uid_partner) => {
    httpClient(
      "GET",
      `${ApiEndpoint}campaigns/shortLinks/${uid_partner}`,
      {},
      token
    ).then((response) => {
      formik.setFieldValue(
        "listShortLinks",
        response.data.filter((x) => x.active),
        false
      );
    });
  };

  const getExtraFieldsInfo = (uidDatabase) => {
    httpClient(
      "GET",
      `${ApiEndpoint}campaigns/fieldsdatabase/${uidDatabase}`,
      {},
      token
    ).then((response) => {
      formik.setFieldValue("fieldsInfo", response.data, false);
    });
  };

  const getAvMask = (uid_partner) => {
    httpClient(
      "GET",
      `${ApiEndpoint}campaigns/masks/${uid_partner}`,
      {},
      token
    ).then((response) => {
      formik.setFieldValue("listMask", response.data, false);
    });
  };

  useEffect(() => {
    getCustomersList();
    getListDatabase();
  }, []);

  useEffect(() => {
    if (formik.values.id_customer) {
      getPartnersList(formik.values.id_customer);
    }
  }, [formik.values.id_customer]);

  useEffect(() => {
    if (formik.values.partner) {
      getShortLinks(formik.values.partner);
      getAvMask(formik.values.partner);
    }
  }, [formik.values.partner]);

  useEffect(() => {
    if (formik.values.uiddatabase) {
      getExtraFieldsInfo(formik.values.uiddatabase);
    }
  }, [formik.values.uiddatabase]);

  const onValidate = async () => {
    try {
      const isValid = await formik.validateForm();
      const isSelectedChannel = formik.values.isRcs || formik.values.isSms;

      if (Object.keys(isValid).length !== 0) {
        throw new Error(`Campos inválidos ${JSON.stringify(isValid)}`);
      }

      if (!isSelectedChannel) {
        throw new Error(`Selecciona al menos un canal de envio SMS o RCS`);
      }

      setVisible(true);
    } catch (error) {
      setVisible(false);
      ErrorMessage(error.message);
    }
  };

  useEffect(() => {
    formik.setFieldValue("buttonActions", []);
    formik.setFieldValue("buttonQuickReplies", []);
  }, [formik.values.step]);

  const components = [
    { key: "general", element: <GeneralData /> },
    { key: "channel", element: <ChannelSend /> },
    formik.values.isSms && {
      key: "sms",
      element: <MessageText />,
    },
    formik.values.isRcs && {
      key: "rcs",
      element: <MessageSimpleRcs isAdmin={true} />,
    },
    formik.values.isWhatsapp && {
      key: "whatsapp",
      element: <WhatsappForm />,
    },
    formik.values.isEmail && {
      key: "email",
      element: <EmailForm />,
    },
    {
      key: "scheduler",
      element: <Scheduler isLoading={isLoading} onValidate={onValidate} />,
    },
  ].filter(Boolean);

  return (
    <FormikProvider value={formik}>
      <div className="flex justify-center">
        <div className="space-y-2 w-[1000px]">
          {components.map(({ key, element }, index) =>
            React.cloneElement(element, { step: index + 1, key })
          )}
        </div>
      </div>
      <_ModalConfirmMulti
        title="Confirmar Campaña"
        onClose={() => setVisible(false)}
        onAction={async () => await formik.submitForm()}
        description="¿Estas seguro de crear la campaña?"
        data={formik.values}
        visible={visible}
        isLoading={isLoading}
      />
    </FormikProvider>
  );
};

export default NewCampaignAdminForm;
